//
// GENERATED by KVision
//
package pl.finn.forms.service

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager

expect class FormsService : IFormsService

object FormsServiceManager : KVServiceManager<FormsService>(FormsService::class) {
    init {
        bind(IFormsService::anuluj, HttpMethod.POST, null)
        bind(IFormsService::getPostCodes, HttpMethod.POST, null)
        bind(IFormsService::getPostOffice, HttpMethod.POST, null)
        bind(IFormsService::getTowns, HttpMethod.POST, null)
        bind(IFormsService::getStreets, HttpMethod.POST, null)
        bind(IFormsService::terytKodPocztowySugAction, HttpMethod.POST, null)
    }
}
